"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DataGridContext", {
  enumerable: true,
  get: function get() {
    return _dataGridContext["default"];
  }
});
Object.defineProperty(exports, "setAgGridLicense", {
  enumerable: true,
  get: function get() {
    return _agGridLicense.setAgGridLicense;
  }
});
Object.defineProperty(exports, "GridWithPagination", {
  enumerable: true,
  get: function get() {
    return _gridWithPagination["default"];
  }
});
exports.DefaultCompositionDataGrid = exports["default"] = void 0;

var _dataGrid = _interopRequireDefault(require("./data-grid"));

var _dataGridContext = _interopRequireDefault(require("./data-grid-context"));

var _default2 = _interopRequireDefault(require("./compositions/default"));

var _agGridLicense = require("./ag-grid-license");

var _gridWithPagination = _interopRequireDefault(require("./compositions/grid-with-pagination"));

var DefaultCompositionDataGrid = _default2["default"];
exports.DefaultCompositionDataGrid = DefaultCompositionDataGrid;
var _default = _dataGrid["default"];
exports["default"] = _default;